<template>
  <bimini-default-section :section="section" :menu="menu"
                          class="menu--section-three_column"></bimini-default-section>
</template>

<script lang="ts">
/**
 * Custom component for Bimini three column menu section.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.1.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-03-23 (1.0.0) (jhoward)
 *      - <biminiThreeColumnSection> adds a three column layout for Bimini menu sections.
 *
 *  2025-04-08 (1.1.0) (jhoward)
 *    - Replace "menuVersion" prop with "menu" prop in <biminiThreeColumnSection>.
 */

import {defineComponent, PropType} from "vue";
import BiminiDefaultSection from "./Bimini_defaultSection.vue";
import {Menu, MenuSection} from "../defs";

export default defineComponent({
  name: 'Bimini_threeColumnSection',
  components: {BiminiDefaultSection},
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
  },
})
</script>

<style scoped>

</style>